import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Plus, Minus } from "lucide-react";

export default function FAQ() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(0);

  useEffect(() => {
    api.get("/faq").then((r) => setItems(r.data.faq)).catch(() => {});
  }, []);

  return (
    <section className="border-t border-[#3a3a3a]" data-testid="section-faq">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-6 mb-12">
          <div className="col-span-12 lg:col-span-8">
            <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#cfff04] mb-3">
              08 // FAQ
            </div>
            <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tighter">
              The questions
              <br />
              everyone asks.
            </h2>
          </div>
        </div>

        <div className="border-t border-[#3a3a3a]">
          {items.map((it, i) => {
            const isOpen = open === i;
            return (
              <div key={it.q} className="border-b border-[#3a3a3a]" data-testid={`faq-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left hover:bg-[#121212] transition-colors px-2"
                >
                  <span className="font-display text-lg sm:text-xl font-bold uppercase tracking-tight">
                    {it.q}
                  </span>
                  <span className="flex-shrink-0">
                    {isOpen ? (
                      <Minus size={20} className="text-[#cfff04]" />
                    ) : (
                      <Plus size={20} className="text-[#d0d0d0]" />
                    )}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-2 pb-6 text-[#e2e2e2] leading-relaxed max-w-3xl">
                    {it.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
